import { useRouter } from "next/router";

import { CREATE_AD_V2_ROUTE } from "@/features/create-ad-v2/static/create-ad-v2.static";
import { type SellEntry, sellRoute } from "@/features/us-market/sell-route";
import { isUsLocale } from "@/i18n/config";

/**
 * The one way a sell button finds its target (WHO-6511): `route` everywhere, the US seller
 * waiting list on `/en-us`. `sellingClosed` lets a button skip what only makes sense before the
 * create-ad flow, such as the sign-in wall: the waiting list needs no account.
 */
export const useSellRoute = (
  entry: SellEntry,
  route: string = CREATE_AD_V2_ROUTE
) => {
  const { locale } = useRouter();

  return {
    href: sellRoute(locale, entry, route),
    sellingClosed: isUsLocale(locale),
  };
};
